var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99997 11.5274L14.4039 15.6369C14.6719 15.809 15.0218 15.782 15.2603 15.5707C15.4988 15.3595 15.5679 15.0156 15.4295 14.7286L8.64102 0.652962C8.52234 0.406821 7.99988 0.250366 7.99988 0.250366L7.99979 0.250875C7.73148 0.250964 7.47958 0.402933 7.35901 0.652948L0.570545 14.7286C0.432171 15.0156 0.501264 15.3595 0.739765 15.5707C0.873442 15.6891 1.04219 15.7496 1.21183 15.7496C1.3448 15.7496 1.47838 15.7125 1.59616 15.6369L7.99997 11.5274Z",
    fill: "#3F4D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorth);
export default __webpack_public_path__ + "static/media/north.7313c33d7fd7ef11fed1e903c39295cf.svg";
export { ForwardRef as ReactComponent };